import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ApiV6Service } from '@service/apiv6.service';
import { lastValueFrom } from 'rxjs';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { CommonService } from '@service/common.service';
import { getBskList, getIdList } from '@core/_utils/tools.utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-edit-reqbsk',
    templateUrl: './edit-reqbsk.component.html',
    styleUrls: ['./edit-reqbsk.component.scss'],
})
export class EditReqBskComponent implements OnInit {
    public selectedRequest: any;
    public requestResult: any[];

    @Input()
    public item: any;

    @Input()
    public requestList = [];

    @Input()
    public basketList = [];


    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDeleteItem: EventEmitter<any> = new EventEmitter();

    constructor(
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        public menu: MenuServiceInt,
        private commonService: CommonService,
        private translate: TranslateService
    ) {
        this.menu.display = true;
        this.selectedRequest = new Object();
        this.selectedRequest.notifyParent = new EventEmitter(); 
    }

    ngOnInit() {
        this.getRequest(this.item.reference);
        this.commonService.checkReset();
    }

    private async getRequest(id) {
        let wRes: any;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('getreqbasket', id));
            this.requestResult = wRes.data;
            this.resetRequest();
            if (id !== 0) {
                this.loadRequestData(this.requestResult);
            }            
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));            
        }
    }

    private loadRequestData(adata) {
        this.selectedRequest.id = adata[0].IdReqEntete;
        this.selectedRequest.id_request = adata[0].IdReqEntete;
        this.selectedRequest.requestList = [];
        this.selectedRequest.requestList.push(adata[0].IdReqEntete);
        this.selectedRequest.basketList = [...getBskList(adata)];
        this.selectedRequest.idList = [...getIdList(adata)];
        this.selectedRequest._label = this.item._label;
        this.selectedRequest.notifyParent.emit();
    }

    private resetRequest() {
        this.selectedRequest.id = 0;
        this.selectedRequest.id_request = 0;
        this.selectedRequest.requestList = [];
        this.selectedRequest.basketList = [];
        this.selectedRequest.idList = [];
        this.selectedRequest._label = '';
    }

    delete(data) {
        this.onDeleteItem.emit({ index: this.item.index, id: this.item.id, data: data, item: this.item });
    }

    public async validate (request) {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('updatereqbsk', this.api.createReqBsk(request, request.id, this.selectedRequest.idList)));
            this.onValidate.emit({ index: this.item.index, id: this.item.id, data: wRes.data, create: false });
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            return;
        }
    }

    cancel(event) {
        this.onCancel.emit({ index: this.item.index, id: this.item.id });
    }
}
